/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ConfirmEmailVerificationHeaders = zod.object({
  'idempotency-key': zod.string(),
  'x-csrf-token': zod.string(),
});

export type ConfirmEmailVerificationHeaders = zod.input<typeof ConfirmEmailVerificationHeaders>;
export type ConfirmEmailVerificationHeadersOutput = zod.output<
  typeof ConfirmEmailVerificationHeaders
>;
